import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex flex-wrap w-full space-y-2 md:space-x-2 md:flex-nowrap md:space-y-0" }
const _hoisted_3 = { class: "flex w-full md:w-2/5" }
const _hoisted_4 = ["onKeydown"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-search",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" })
], -1)
const _hoisted_6 = { class: "w-full space-x-2 md:w-1/5" }
const _hoisted_7 = { class: "mt-8 overflow-x-scroll min-h-[420px]" }
const _hoisted_8 = { class: "w-full table-auto" }
const _hoisted_9 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_10 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_11 = { class: "flex items-center justify-between w-full px-2 py-2" }
const _hoisted_12 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_13 = { class: "flex items-center justify-between w-full px-2 py-2" }
const _hoisted_14 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_15 = { class: "flex items-center justify-between w-full px-2 py-2" }
const _hoisted_16 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_17 = { class: "relative flex items-center justify-between px-2 py-2" }
const _hoisted_18 = { class: "capitalize" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_20 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_21 = { class: "flex items-center justify-between w-full px-2 py-2" }
const _hoisted_22 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_23 = { class: "flex items-center justify-between w-full px-2 py-2" }
const _hoisted_24 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_25 = { class: "relative flex items-center justify-between w-full px-2 py-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-2 py-2"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "hidden" }, "Actions")
], -1)
const _hoisted_27 = { class: "px-2 py-6 capitalize md:py-3" }
const _hoisted_28 = { class: "px-2 py-2 capitalize" }
const _hoisted_29 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "px-2 py-2 capitalize" }
const _hoisted_33 = { class: "px-2 py-2 capitalize" }
const _hoisted_34 = { class: "px-2 py-2 capitalize" }
const _hoisted_35 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_36 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_37 = { class: "px-2 py-2 capitalize" }
const _hoisted_38 = { class: "px-2 py-2" }

import { ref } from "vue";
import { useRoute } from "vue-router";

import RoleGuard from "@/components/RoleGuard.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import RouterButton from "@/components/RouterButton.vue";
import PaginationBar from "@/components/PaginationBar.vue";
import FilterTableHeader from "@/components/tables/FilterTableHeader.vue";
import SortableTableHeader from "@/components/tables/SortableTableHeader.vue";

import api from "../../api/api";
import { Discount, PaginationMeta } from "../../types";
import { useFilters } from "@/composables/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'DiscountsList',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const { filters, setFilter, setFilterNoRefresh, resetFilters, sortBy, getFiltersFromQuery } = useFilters(route);

const discounts = ref([] as Discount[]);
const meta = ref({} as PaginationMeta);

const merchants = ref(["stripe", "2checkout"] as string[]);
const archivedFilters = [
  { key: "yes", value: "true" },
  { key: "no", value: "false" },
];

async function search() {
  const response = await api.discounts.listDiscounts(filters.value as any);
  discounts.value = response.data.discounts;
  meta.value = response.meta;
}

setFilterNoRefresh("archived", "false");

getFiltersFromQuery();
;(
  ([__temp,__restore] = _withAsyncContext(() => search())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(TitleHeader, {
        title: _ctx.$t('discounts')
      }, null, 8, ["title"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            type: "search",
            id: "search",
            onKeydown: _withKeys(search, ["enter"]),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).search) = $event)),
            class: "block w-full h-10 py-2 text-gray-900 border border-gray-600 rounded-l",
            placeholder: "Search ...",
            required: ""
          }, null, 40, _hoisted_4), [
            [_vModelText, _unref(filters).search]
          ]),
          _createElementVNode("button", {
            onClick: search,
            class: "flex items-center h-10 px-4 py-2 space-x-2 text-white rounded-r whitespace-nowrap bg-primary hover:bg-blue-700"
          }, [
            _hoisted_5,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("search")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(RoleGuard, { roles: ['admin'] }, {
            default: _withCtx(() => [
              _createVNode(RouterButton, {
                type: "secondary",
                loading: false,
                disabled: false,
                to: { path: '/dashboard/courses/discounts/new' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("add-a-discount")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_9, [
              _createElementVNode("th", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("name")), 1),
                  (_unref(filters))
                    ? (_openBlock(), _createBlock(SortableTableHeader, {
                        key: 0,
                        label: "name",
                        column: "name",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("th", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("code")), 1),
                  (_unref(filters))
                    ? (_openBlock(), _createBlock(SortableTableHeader, {
                        key: 0,
                        label: "code",
                        column: "code",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("th", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("usage")), 1),
                  (_unref(filters))
                    ? (_openBlock(), _createBlock(SortableTableHeader, {
                        key: 0,
                        column: "usagecount",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("th", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t(`merchant-name`)), 1),
                  (_unref(filters))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createVNode(SortableTableHeader, {
                          label: "Merchant",
                          column: "merchant_name",
                          onSort: _unref(sortBy)
                        }, null, 8, ["onSort"]),
                        _createVNode(FilterTableHeader, {
                          label: "merchant",
                          currentValue: _unref(filters).merchant,
                          filters: merchants.value,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("th", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("expires")), 1),
                  (_unref(filters))
                    ? (_openBlock(), _createBlock(SortableTableHeader, {
                        key: 0,
                        label: "expires_at",
                        column: "expires_at",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("th", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("status")), 1),
                  (_unref(filters))
                    ? (_openBlock(), _createBlock(SortableTableHeader, {
                        key: 0,
                        column: "active",
                        onSort: _unref(sortBy)
                      }, null, 8, ["onSort"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("th", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("archived")), 1),
                  _createVNode(FilterTableHeader, {
                    label: "archived",
                    currentValue: _unref(filters).archived,
                    filters: archivedFilters,
                    onChange: _unref(setFilter),
                    onReset: _unref(resetFilters),
                    isObjectArray: true
                  }, null, 8, ["currentValue", "onChange", "onReset"])
                ])
              ]),
              _hoisted_26
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(discounts.value, (discount) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "border-b border-gray-400 divide-x divide-gray-300",
                key: discount.id
              }, [
                _createElementVNode("td", _hoisted_27, _toDisplayString(discount.name), 1),
                _createElementVNode("td", _hoisted_28, _toDisplayString(discount.code), 1),
                _createElementVNode("td", _hoisted_29, [
                  (discount.limit)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(discount.usagecount) + "/" + _toDisplayString(discount.limit), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(discount.usagecount) + "/" + _toDisplayString(_ctx.$t("unlimited")), 1))
                ]),
                _createElementVNode("td", _hoisted_32, _toDisplayString(discount.merchant_name), 1),
                _createElementVNode("td", _hoisted_33, _toDisplayString(new Date(discount.expires_at).toDateString()), 1),
                _createElementVNode("td", _hoisted_34, [
                  (discount.active)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.$t("active")), 1))
                    : _createCommentVNode("", true),
                  (!discount.active)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.$t("inactive")), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("td", _hoisted_37, _toDisplayString(discount.archived ? _ctx.$t("yes") : _ctx.$t("no")), 1),
                _createElementVNode("td", _hoisted_38, [
                  _createVNode(_component_router_link, {
                    to: `/dashboard/courses/discounts/${discount.id}`,
                    class: "text-blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _createVNode(PaginationBar, { meta: meta.value }, null, 8, ["meta"])
  ], 64))
}
}

})